import React, { useEffect, useState } from "react";
import { MapMarker, Organization } from "../common/ObjectTypes";
import { toast } from "react-toastify";
import MapMarkersList from "./MapMarkersList";
import {
  createMapMarker,
  deleteMapMarker,
  getMapMarkers,
  updateMapMarker,
} from "../../api/mapMarkers/mapMarkersApi";
import { useNavigate } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import { getOrganizations } from "../../api/organizations/organizationsApi";
import { getWildXROrgId } from "../../helpers/wildXROrgIdHelper";
import { getCurrentUser } from "../../helpers/authHeader";

type ManageMapMarkersControllerProps = {
  selectMapMarkersPage: boolean;
  onSelectMapMarkerForVideo?: Function;
  isVideoMapMarkerIncluded?: Function | undefined;
  onSelectMapMarkerForCatalogue?: Function;
  isCatalogueMapMarkerIncluded?: Function | undefined;
  onSelectAllMapMarkers?: Function | undefined;
  areAllMapMarkersSelected?: boolean;
  isLoadingForCatalogueSelectAll?: boolean;
  onSelectAllMapMarkersForVideo?: Function | undefined;
  isLoadingForVideo?: boolean;
  isDisabled?: boolean;
};
//have a mapMarkers list to conditionally render the list of mapMarkers
const ManageMapMarkersController: React.FC<ManageMapMarkersControllerProps> = ({
  selectMapMarkersPage,
  onSelectMapMarkerForVideo,
  isVideoMapMarkerIncluded,
  onSelectMapMarkerForCatalogue,
  isCatalogueMapMarkerIncluded,
  onSelectAllMapMarkers,
  areAllMapMarkersSelected,
  isLoadingForCatalogueSelectAll,
  onSelectAllMapMarkersForVideo,
  isLoadingForVideo,
  isDisabled,
}) => {
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const [pageLoaded, setPageLoaded] = useState(false);
  const wpsOrgId = "b1df7f5a-5ed7-4ae9-97dc-e78b9137a0b3";
  const [mapMarkers, setMapMarkers] = useState<MapMarker[]>([]);
  const [customMapMarkers, setCustonMapMarkers] = useState<MapMarker[]>([]);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [addMapMarker, setAddMapMarker] = useState(false);
  const [selectedMapMarker, setSelectedMapMarker] = useState<MapMarker>({
    name: "",
    mapMarkerId: "",
    description: "",
    latitude: 0,
    longitude: 0,
    iconID: 0,
    rowVersion: "",
    organizationId: "",
    videos: [],
  });
  const [mapMarkerToAdd, setMapMarkerToAdd] = useState<MapMarker>({
    name: "",
    mapMarkerId: "",
    description: "",
    latitude: 0,
    longitude: 0,
    iconID: 0,
    rowVersion: "",
    organizationId: "",

    videos: [],
  });

  useEffect(() => {
    const loadMapMarkers = async () => {
      try {
        const temp = await getMapMarkers();
        loadOrgs();
        const userMapMarkers = temp.filter(
          (mapMarker: MapMarker) => mapMarker.organizationId !== wpsOrgId
        );
        const wpsMapMarkers = temp.filter(
          (mapMarker: MapMarker) => mapMarker.organizationId === wpsOrgId
        );

        setCustonMapMarkers(userMapMarkers);
        setMapMarkers(wpsMapMarkers);
        setPageLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };

    const loadOrgs = async () => {
      try {
        const temp = await getOrganizations();
        setOrganizations(temp);
      } catch (err) {
        console.log(err);
      }
    };

    if (!pageLoaded) loadMapMarkers();
  }, [pageLoaded]);

  const handleOnClickAdd = () => {
    navigate("/mapMarker/add");
  };
  const handleSelectMapMarker = (mapMarkerId: string) => {
    navigate("/mapMarker/" + mapMarkerId + "/edit");
  };

  // this function is for adding a mapMarker to object of the multistep form the list is in
  const addMapMarkerToState = (mapMarker: MapMarker) => {
    setMapMarkers([...mapMarkers, mapMarker]);
  };

  const handleChange = (e: any) => {
    const name = e.target.name;
    if (name === "name") {
      setSelectedMapMarker((prev: MapMarker) => ({
        ...prev,
        name: e.target.value,
      }));
    } else if (name === "description") {
      setSelectedMapMarker((prev: MapMarker) => ({
        ...prev,
        description: e.target.value,
      }));
    } else if (name === "location") {
      setSelectedMapMarker((prev: MapMarker) => ({
        ...prev,
        location: e.target.value,
      }));
    }
  };

  const handleChangeNewMapMarker = (e: any) => {
    const name = e.target.name;
    if (name === "newName") {
      setMapMarkerToAdd((prev: MapMarker) => ({
        ...prev,
        name: e.target.value,
      }));
    } else if (name === "newDescription") {
      setMapMarkerToAdd((prev: MapMarker) => ({
        ...prev,
        description: e.target.value,
      }));
    } else if (name === "newLocation") {
      setMapMarkerToAdd((prev: MapMarker) => ({
        ...prev,
        location: e.target.value,
      }));
    }
  };

  const handleUpdateMapMarker = async () => {
    try {
      await updateMapMarker(selectedMapMarker);
      toast.success("MapMarker updated.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveNew = async () => {
    try {
      await createMapMarker({ name: mapMarkerToAdd.name });
      toast.success(mapMarkerToAdd.name + " added.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setMapMarkerToAdd({
        name: "",
        mapMarkerId: "",
        description: "",
        latitude: 0,
        longitude: 0,
        iconID: 0,
        rowVersion: "",
        organizationId: "",
        videos: [],
      });
      setAddMapMarker(false);
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelEdit = () => {
    setSelectedMapMarker({
      name: "",
      mapMarkerId: "",
      description: "",
      latitude: 0,
      longitude: 0,
      iconID: 0,
      rowVersion: "",
      organizationId: "",
      videos: [],
    });
  };

  const handleCancelAdd = () => {
    setAddMapMarker(false);
  };

  const handleDelete = async () => {
    try {
      await deleteMapMarker(
        selectedMapMarker.mapMarkerId ? selectedMapMarker.mapMarkerId : ""
      );
      setSelectedMapMarker({
        name: "",
        mapMarkerId: "",
        description: "",
        latitude: 0,
        longitude: 0,
        iconID: 0,
        rowVersion: "",
        organizationId: "",
        videos: [],
      });
      toast.success("MapMarker was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  return !pageLoaded ? (
    <div className="flex justify-center items-center">
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <div className="h-full">
      <MapMarkersList
        mapMarkers={mapMarkers}
        customMapMarkers={customMapMarkers}
        organizations={organizations}
        selectedMapMarker={selectedMapMarker}
        mapMarkerToAdd={mapMarkerToAdd}
        addMapMarker={addMapMarker}
        onClickAdd={handleOnClickAdd}
        onSelectMapMarker={handleSelectMapMarker}
        onChange={handleChange}
        onChangeNewMapMarker={handleChangeNewMapMarker}
        onCancelEdit={handleCancelEdit}
        onCancelAdd={handleCancelAdd}
        onSaveNew={handleSaveNew}
        onUpdateMapMarker={handleUpdateMapMarker}
        onDelete={handleDelete}
        selectMapMarkersPage={selectMapMarkersPage}
        onSelectMapMarkerForVideo={onSelectMapMarkerForVideo}
        isMapMarkerIncluded={isVideoMapMarkerIncluded}
        onSelectMapMarkerForCatalogue={onSelectMapMarkerForCatalogue}
        isCatalogueMapMarkerIncluded={isCatalogueMapMarkerIncluded}
        onSelectAllMapMarkers={onSelectAllMapMarkers}
        areAllMapMarkersSelected={areAllMapMarkersSelected}
        isLoadingForCatalogueSelectAll={isLoadingForCatalogueSelectAll}
        onSelectAllMapMarkersForVideo={onSelectAllMapMarkersForVideo}
        isLoadingForVideo={isLoadingForVideo}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default ManageMapMarkersController;
